module.exports = __webpack_public_path__ + "img/app.a62b709f.jpg";